module.exports = __webpack_public_path__ + "static/media/view-mongdb.1208fb4c.svg";